import React, { ComponentType } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router';

/**
 * HOC that provides react-router v7 hooks as props to class components.
 * Replaces the v5 pattern where <Route component={X}> injected match/location/history.
 */
export function withRouter<P extends object>(
    Component: ComponentType<P & { match?: any; navigate?: any; location?: any }>,
) {
    const Wrapper = (props: Omit<P, 'navigate' | 'location'>) => {
        const navigate = useNavigate();
        const params = useParams();
        const location = useLocation();
        const match = { params, path: location.pathname, url: location.pathname, isExact: true };
        return <Component {...(props as P)} navigate={navigate} match={match} location={location} />;
    };
    Wrapper.displayName = `withRouter(${Component.displayName || Component.name})`;
    return Wrapper;
}
